import React from "react";
import { Input, Radio, Typography } from "@arco-design/web-react";
import { afterConfirmOptions, afterConfirmSummary } from "../afterConfirm";

const { Text } = Typography;

// "After they click Confirm, they…" (see afterConfirm.js): one choice, with
// their page's address right under the option that uses it, and the flow in a
// line below.
export default function AfterConfirmQuestion({ withReward, choice, onChoice, url, onUrl, urlMissing }) {
    const options = afterConfirmOptions(withReward);
    return (
        <div>
            <div style={{ fontWeight: 500, marginBottom: 6 }}>After they click Confirm, they…</div>
            <Radio.Group direction="vertical" value={choice} onChange={onChoice} style={{ width: "100%" }}>
                {options.map((o) => (
                    <div key={o.value} style={{ marginBottom: 2 }}>
                        <Radio value={o.value}>{o.label}</Radio>
                        {o.usesUrl && choice === o.value && (
                            <div data-fix-field="confirmed_url" style={{ margin: "4px 0 6px 24px" }}>
                                <Input
                                    value={url}
                                    placeholder="https://yoursite.com/welcome"
                                    status={urlMissing ? "error" : undefined}
                                    onChange={onUrl}
                                    autoFocus={!url}
                                />
                                {urlMissing && <Text style={{ color: "rgb(var(--red-6))", fontSize: 12 }}>Enter your page's address.</Text>}
                            </div>
                        )}
                    </div>
                ))}
            </Radio.Group>
            <Text type="secondary" style={{ fontSize: 12, display: "block", marginTop: 4 }}>{afterConfirmSummary(choice, url)}</Text>
        </div>
    );
}
